"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSpotlight = exports.default = void 0;

var _Plugin2 = _interopRequireDefault(require("./Plugin"));

var PIXI = _interopRequireWildcard(require("pixi.js-legacy"));

var _ = require("../../../");

var _2 = require("../../..");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SPOTLIGHT_DURATION = 2500; // ms

var Spotlight = /*#__PURE__*/function (_Plugin) {
  _inherits(Spotlight, _Plugin);

  var _super = _createSuper(Spotlight);

  function Spotlight() {
    var _this;

    _classCallCheck(this, Spotlight);

    _this = _super.call(this);
    _this._name = "Spotlight";
    _this.enabled = true;
    _this.spotlight = null;
    _this.sticker = null;
    _this.controlsVideo = true;
    _this.spotlightPaused = false;
    _this.showing = false;
    _this.showVideoStart = null;
    _this.showStart = null;
    _this.showEnd = null;
    _this.lastUpdateTime = 0;
    _this.videoTimeBuffer = 0;
    _this.videoPaused = false;
    _this.background = null;
    return _this;
  }

  _createClass(Spotlight, [{
    key: "shouldShowSpotlight",
    value: function shouldShowSpotlight(videoInfo) {
      var show = this.enabled;

      if (videoInfo.fullscreen && (0, _2.isLandscape)()) {
        show = false;
      }

      return show;
    }
  }, {
    key: "videoInfo",
    value: function videoInfo() {
      if (this.showing || this.background && this.background.visible) {
        var vi = {
          paused: this.videoPaused
        };
        return vi;
      }

      return {};
    }
  }, {
    key: "videoPause",
    value: function videoPause() {
      if (this.showing) {
        this.showEnd += 1000 * 60 * 60 * 24;
        this.videoPaused = true;
        return false;
      }

      return true;
    }
  }, {
    key: "videoPlay",
    value: function videoPlay() {
      if (this.showing) {
        this.showEnd = 0;
        this.videoPaused = false;
      }

      return true;
    }
  }, {
    key: "videoSetCurrentTime",
    value: function videoSetCurrentTime() {
      if (this.showing) {
        this.showEnd = 0;
        this.videoPaused = false;
      }

      return true;
    }
  }, {
    key: "dataToShare",
    value: function dataToShare() {
      return {
        spotlight_showing: this.showing
      };
    }
  }, {
    key: "setup",
    value: function setup(frame, videoInfo, pixi) {
      _get(_getPrototypeOf(Spotlight.prototype), "setup", this).call(this, frame, videoInfo, pixi);
    }
  }, {
    key: "update",
    value: function update(frame, videoInfo, pixi) {
      _get(_getPrototypeOf(Spotlight.prototype), "update", this).call(this);

      if (this.needsSetup) {
        return;
      }

      var spotlights = (0, _.getProperty)("moment.spotlights", videoInfo, null);

      if (spotlights && spotlights.length > 0) {
        this.spotlight = spotlights[spotlights.length - 1];
      } else {
        this.spotlight = null;
      } // no spotlight, stop showing if we are


      if (!this.spotlight) {
        this.showing = false;
      }

      var curSpotUTC = -1;

      if (this.spotlight) {
        curSpotUTC = this.spotlight.utc;
      }

      if (this._lastSpotUTC !== curSpotUTC) {
        // spotlights changed abort if showing
        this.lastUpdateTime = videoInfo.currentTime * 1000;
        this.showing = false;
      }

      this._lastSpotUTC = curSpotUTC;
      var now = new Date().getTime();
      var vt = videoInfo.currentTime * 1000;
      var spotTime = -999;
      var videoTime = 0; // calculate times

      if (this.spotlight && videoInfo.moment) {
        spotTime = this.spotlight.utc;

        if (this.spotlight.corr) {
          spotTime += this.spotlight.corr;
        }

        videoTime = videoInfo.moment.start_time - videoInfo.moment.dynamic_offset * 1000;
        videoTime += vt;
      }

      var timeSinceLastUpdate = videoTime - this.lastUpdateTime; // ensure valid last update time

      if (this.lastUpdateTime === 0) {
        this.lastUpdateTime = videoTime;
      } // ignore significant time changes


      if (timeSinceLastUpdate < 0 || timeSinceLastUpdate > 400) {
        this.showing = false;
        this.videoPaused = false;
        this.showStart = null;
        this.showEnd = null;
        this.showVideoStart = null;
        this.videoTimeBuffer = 0; // console.log(
        //     "** Spotlight resetting timers significant time change: ",
        //     timeSinceLastUpdate
        // )
      } // is spotlight time between last update time and current time
      else if (this.videoTimeBuffer === 0 && this.shouldShowSpotlight(videoInfo) && this.enabled && this.spotlight && !this.showing && this.lastUpdateTime < spotTime && spotTime < videoTime) {
        this.showVideoStart = videoTime;
        this.showStart = now;
        this.showEnd = now + SPOTLIGHT_DURATION;
        this.videoControls.pause();
        this.showing = true; // console.log(
        //     "++ Spotlight showing",
        //     this.lastUpdateTime,
        //     spotTime,
        //     this.videoTimeBuffer
        // )
      } else if (this.spotlight && this.showing && this.showEnd < now) {
        // check if showing is done
        this.showing = false;
        this.videoPaused = false;
        this.showStart = null;
        this.showEnd = null;
        this.showVideoStart = null;
        var vc = this.videoControls;
        vc.play();
        this.videoTimeBuffer = now - this.lastUpdateTime * 24; // console.log(
        //     "-- Spotlight dismissing",
        //     this.lastUpdateTime,
        //     spotTime,
        //     this.videoTimeBuffer
        // )
      } // else {
      //     let lutDiff = this.lastUpdateTime - videoTime
      //     let vtDiff = spotTime - videoTime
      //     console.log(
      //         "??? Spotlight checking",
      //         spotTime,
      //         lutDiff,
      //         vtDiff,
      //         this.lastUpdateTime,
      //         videoTime
      //     )
      // }


      if (this.videoTimeBuffer > 0) {
        this.videoTimeBuffer = this.videoTimeBuffer - 16;

        if (this.videoTimeBuffer < 30) {
          this.videoTimeBuffer = 0;
        }
      } // update last update time


      this.lastUpdateTime = videoTime + this.videoTimeBuffer;

      if (!this.showing) {
        if (this.backgroundLayer) {
          this.scene.removeChild(this.backgroundLayer);
          this.backgroundLayer = null;
        }
      } else {
        var fieldFrame = this.videoFrame;
        var bh = this.spotlight.height / 1000 * fieldFrame.h;
        var cp = {
          x: this.spotlight.center[0] / 1000 * fieldFrame.w + fieldFrame.x,
          y: this.spotlight.center[1] / 1000 * fieldFrame.h + fieldFrame.y + bh
        };
        this.drawSpotlight(frame, cp);
      }

      if (this.isResizing) {
        this.scene.alpha = 0;
        this.scene.removeChild(this.backgroundLayer);
        this.backgroundLayer = null;
      } else {
        this.scene.alpha = 1;
      }
    }
  }, {
    key: "drawSpotlight",
    value: function drawSpotlight(frame, cp) {
      if (!this.backgroundLayer) {
        var spotScale = frame.w / 438;
        var spotWidth = 30;
        var spotWidthAdjust = cp.y / 1000 * 100;
        spotWidth = (spotWidth + spotWidthAdjust) * spotScale;
        var spw = spotWidth / 2;
        var halfTopWidth = spotWidth * 0.4;
        var layer = new PIXI.Graphics();
        layer.beginFill(0x000000, 0.4);
        layer.moveTo(0, 0);
        layer.lineTo(0, frame.h);
        layer.lineTo(frame.w, frame.h);
        layer.lineTo(frame.w, 0); // Spotlight funndel

        layer.lineTo(cp.x + halfTopWidth, 0);
        layer.lineTo(cp.x + spw, cp.y);
        layer.bezierCurveTo(cp.x + spw, cp.y + spw / 2, cp.x - spw, cp.y + spw / 2, cp.x - spw, cp.y); // curve

        layer.lineTo(cp.x - halfTopWidth, 0);
        layer.lineTo(0, 0);
        layer.closePath();
        layer.endFill();
        this.backgroundLayer = layer;
        this.scene.addChild(layer);
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      _get(_getPrototypeOf(Spotlight.prototype), "reset", this).call(this);

      if (this.scene && this.backgroundLayer) {
        this.scene.removeChild(this.backgroundLayer);
      }

      this.backgroundLayer = null;
      this.showing = false;
      this.showVideoStart = null;
      this.showStart = null;
      this.showEnd = null;
      this.lastUpdateTime = 0;
    }
  }]);

  return Spotlight;
}(_Plugin2.default);

exports.default = Spotlight;

var getSpotlight = function getSpotlight(event, playlist, timeline) {
  if (event && playlist && playlist.scope && playlist.scope.player && timeline && timeline.spotlight && timeline.spotlight.length > 0) {
    var eventVideoOffset = event.dynamic.offset * 1000;
    var eventStart = event.utc_time - eventVideoOffset;
    var eventEnd = eventStart + event.dynamic.duration * 1000;
    var playlistTN = parseInt(playlist.scope.player.id, 10);
    var possibleSpotlights = [];

    var _iterator = _createForOfIteratorHelper(timeline.spotlight),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var spot = _step.value;
        var spotTime = spot.utc;
        var playerCheck = false;
        var timeCheck = false;

        if (playlistTN === spot.trace_number) {
          playerCheck = true;
        }

        if (eventStart < spotTime && spotTime < eventEnd) {
          timeCheck = true;
        }

        if (playerCheck && timeCheck) {
          spot.video_start = spotTime;
          spot.video_end = spotTime;
          spot.video_time = spotTime;
          spot.rank = spot.utc;
          possibleSpotlights.push(spot);
        }
      } // Pick spotlight

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    possibleSpotlights.sort(function (a, b) {
      return a.rank - b.rank;
    });
    var spotlight = null;

    if (possibleSpotlights.length >= 1) {
      spotlight = possibleSpotlights[0];
    }

    return spotlight;
  }

  return null;
};

exports.getSpotlight = getSpotlight;